import { takeEvery, call, put, all, select } from "redux-saga/effects";
import { actionTypes, actions } from "./actions";
import { actions as commonActions } from "../../../store/actions";
import { getProductByIdAPI, getProductsAPI, updateProductAPI } from "./endpoints";

function* getProductsSaga(action) {
  try {
    yield put(commonActions.setLoading(true));
    const _api = yield call(getProductsAPI, action.payload);
    yield put(actions.setProducts(_api.data.results));
    yield put(commonActions.setLoading(false));
  } catch (error) {
    yield put(commonActions.setLoading(false));
    console.log(error);
  }
}

function* getProductByIdSaga(action) {
  try {
    yield put(actions.setEditProductLoader(true));
    const _api = yield call(getProductByIdAPI, action.payload);
    yield put(actions.setProductById(_api.data.results));
    yield put(actions.setEditProductLoader(false));
  } catch (error) {
    yield put(actions.setEditProductLoader(false));
    console.log(error);
  }
}

// function* savePartnersSaga(action) {
//   try {
//     yield put(commonActions.setLoading(true));
//     const _api = yield call(savePartnersAPI, action.payload);
//     if (_api?.data?.success) {
//       yield put(actions.getPartners());
//       yield put(
//         commonActions.setAlert({
//           message: "Partner Saved Successfully",
//           alertType: "success",
//           showToast: true,
//         })
//       );
//     }
//     yield put(commonActions.setLoading(false));
//   } catch (error) {
//     yield put(
//       commonActions.setAlert({
//         message: error.message || "Save Partner Failed",
//         alertType: "error",
//         showToast: true,
//       })
//     );
//     yield put(commonActions.setLoading(false));
//     console.log(error);
//   }
// }

const getCommonState = (state) => state?.common;

function* updateProductSaga(action) {
  try {
    yield put(actions.setEditProductLoader(true));
    const _api = yield call(updateProductAPI, action.payload);
    if (_api?.data?.success) {
      const common = yield select(getCommonState);
      const imdl = common?.userInfo?.userGroups?.join(",");
      yield put(actions.getProducts({ select: 'all', SAMAccountName: imdl }));
      yield put(
        commonActions.setAlert({
          message: "Product Updated Successfully",
          alertType: "success",
          showToast: true,
        })
      );
    }
    yield put(actions.setEditProductLoader(false));
  } catch (error) {
    yield put(
      commonActions.setAlert({
        message: error?.response?.data?.message || error.message || "Update Product Failed",
        alertType: "error",
        showToast: true,
      })
    );
    yield put(actions.setEditProductLoader(false));
    console.log(error);
  }
}

export function* withProductsSaga() {
  yield all([
    takeEvery(actionTypes.GET_PRODUCTS, getProductsSaga),
    takeEvery(actionTypes.GET_PRODUCT_BY_ID, getProductByIdSaga),
    takeEvery(actionTypes.UPDATE_PRODUCTS, updateProductSaga),
    // takeEvery(actionTypes.SAVE_PRODUCTS, savePartnersSaga),
  ]);
}
